import {useNavigate} from 'react-router-dom';
import StatusBadge from '../../../../components/statusBadge';

interface IProps {
  item: ISubBrand;
  isOwner?: boolean;
}

const ProductCard = ({item, isOwner}: IProps) => {
  const navigate = useNavigate();

  const mainImgSrc = (item: ISubBrand) => {
    if (!item.images || item.images.length === 0) return '';

    // Try to find an image by main_image identifier
    const mainImg = item.images.find(
      img => img.id.toString() === item.main_image,
    );

    if (mainImg) {
      return (
        mainImg.image ||
        mainImg.image_1024 ||
        mainImg.image_330 ||
        mainImg.image_128 ||
        ''
      );
    }

    // Fallback to the first image if the main image not found
    const firstImg = item.images[0];
    return (
      firstImg.image ||
      firstImg.image_1024 ||
      firstImg.image_330 ||
      firstImg.image_128 ||
      ''
    );
  };

  return (
    <div
      className="flex items-center justify-between gap-3 p-3 border shadow-sm rounded-xl"
      onClick={() => navigate(`subBrand/${item.id}`)}
    >
      <div className="flex items-center justify-center gap-2">
        <img
          src={mainImgSrc(item)}
          alt="brand"
          className="object-cover rounded-lg w-11 h-11"
        />
        <span className="text-md">{item.name}</span>
      </div>

      {isOwner &&
        item.status !== 'accept' && ( // Only show when an item's status is 'pending' or 'reject'
          <StatusBadge status={item.status} />
        )}
    </div>
  );
};

export default ProductCard;
